import React from 'react'
import styled from 'styled-components'

import Input from '../Input'
import { IInputNumber } from './index'

const SWrapper = styled.div`
  display: flex;
  height: 40px;

  & > * {
    border-radius: 0;
  }

  & > *:first-child {
    border-top-left-radius: ${(props => props.theme.general.borderRadius)};
    border-bottom-left-radius: ${(props => props.theme.general.borderRadius)};
  }

  & > *:last-child {
    border-top-right-radius: ${(props => props.theme.general.borderRadius)};
    border-bottom-right-radius: ${(props => props.theme.general.borderRadius)};
  }
`

const SInput = styled(Input)`
  height: 100%;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type=number] {
    -moz-appearance: textfield;
  }
`

const SButton = styled.div`
  cursor: pointer;
  height: 100%;
  width: 57px;
  border: 1px solid ${props => props.theme.colors.accent};
  font-size: 24px;
  font-weight: 500;
  line-height: 40px;
  text-align: center;
  user-select: none;
  transition: 0.3s;
  flex-grow: 0;
  flex-shrink: 0;

  &:hover {
    background-color: ${props => props.theme.colors.accent};
    color: white
  }

  &:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
  }
`

const InputNumber: React.FC<IInputNumber> = (props) => {
  const { value, className, onIncrement, onDecrement, ...rest } = props

  return (
    <SWrapper className={className}>
      {!!onDecrement && <SButton onClick={onDecrement}>–</SButton>}
      <SInput type="number" value={value} {...rest}/>
      {!!onIncrement && <SButton onClick={onIncrement}>+</SButton>}
    </SWrapper>
  )
}

export default InputNumber